import { Grid, HStack, Icon, Link, Text, VStack } from "@chakra-ui/react";
import React, { FC, useMemo } from "react";
import HorizontalProductCard from "../../molecules/HorizontalProductCard";
import { fetchAllProducts } from "../../../queries/fetchAllProducts";
import useAuth from "../../useAuth";
import { MdChevronRight } from "../../customIcons";

type SubstituteProductsType = {
  substitute: any[];
  categoryName: string;
  categorySlug: string;
};

const SubstituteProducts: FC<SubstituteProductsType> = ({
  substitute,
  categoryName,
  categorySlug,
}: any) => {
  const { isUnlicensedUser, loggedIn, isCustomerDefault, isBankAcc } =
    useAuth();
  const productSkus = substitute?.map((item: any) => item.productSku);
  const allProducts = fetchAllProducts();

  const filteredProducts = useMemo(() => {
    const shouldFilterByRestrictions =
      isUnlicensedUser || !loggedIn || isCustomerDefault || isBankAcc;
    const filteredBySkus = allProducts.filter(
      (item: any) => productSkus?.includes(item.sku),
    );

    return shouldFilterByRestrictions
      ? filteredBySkus.filter((item: any) => {
          return !item.productTags.nodes.some(
            (node: any) => node.name === "Pharmaceuticals",
          );
        })
      : filteredBySkus;
  }, [
    productSkus,
    allProducts,
    isUnlicensedUser,
    !loggedIn,
    isCustomerDefault,
    isBankAcc,
  ]);

  return (
    <>
      {filteredProducts.length === 0 ? (
        <></>
      ) : (
        <HStack
          spacing={8}
          mx="auto"
          flexDir={{ base: "column", xl: "row" }}
          w="100%"
          bg="#F7FAFC"
          borderRadius="16px"
          p={{ base: 4, lg: 10 }}
          alignItems="flex-start"
        >
          <VStack
            w="100%"
            spacing={8}
            alignItems="flex-start"
            maxW="450px"
            gap={2}
          >
            <Text fontSize="20px" fontWeight="700">
              Substitute Products
            </Text>
            <Text fontSize="18px" color="#4A5568">
              Check out these alternatives that might suit your needs
            </Text>
            <HStack color="#A24468" pt={3} lineHeight="24px">
              <Link
                href={`https://www.medsupplysolutions.com/${categorySlug}/`}
                fontSize="18px"
                fontWeight="600"
              >
                View more alternatives from {categoryName}
                <Icon h="16px" w="16px" as={MdChevronRight} ml={1} />
              </Link>
            </HStack>
          </VStack>
          <Grid
            w="100%"
            maxW={{ base: "500px", xl: "720px" }}
            templateColumns={{
              base: "repeat(1, 1fr)",
              lg: "repeat(2, 1fr)",
            }}
            gap={2}
          >
            {filteredProducts?.map((item: any) => {
              const imageData =
                item.featuredImage?.node?.localFile?.childImageSharp
                  ?.gatsbyImageData;
              const altText = item.featuredImage?.node?.altText;
              return (
                <HorizontalProductCard
                  key={item.databaseId}
                  name={item.name}
                  price={item.price}
                  salePrice={item.salePrice}
                  productId={item.databaseId}
                  slug={item.slug}
                  regularPrice={item.regularPrice}
                  tierPrice={item?.tierPrice?.tierPrice}
                  imageData={imageData}
                  altText={altText}
                />
              );
            })}
          </Grid>
        </HStack>
      )}
    </>
  );
};

export default SubstituteProducts;
